import { ReactElement, useState } from 'react';
import { Button, Popconfirm } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { MessageInstance } from 'antd/es/message/interface';

const MIN_RETRY_DURATION_SECONDS = 10;

interface Props {
  duration: number | null;
  onRetry: () => Promise<{ success: boolean }>;
  messageApi: MessageInstance;
}

const RetryButton = ({ duration, onRetry, messageApi }: Props): ReactElement => {
  const [retrying, setRetrying] = useState(false);

  const handleRetry = async () => {
    if (duration !== null && duration <= MIN_RETRY_DURATION_SECONDS) {
      void messageApi.warning('録音時間が短いためリトライできません');
      return;
    }

    setRetrying(true);
    try {
      await onRetry();
    } finally {
      setRetrying(false);
    }
  };

  return (
    <Popconfirm
      title='文字起こし・要約を再実行しますか？'
      onConfirm={() => {
        void handleRetry();
      }}
      okText='リトライ'
      cancelText='キャンセル'
    >
      <Button type='text' icon={<ReloadOutlined />} loading={retrying}>
        リトライ
      </Button>
    </Popconfirm>
  );
};

export default RetryButton;
